import { useState } from "react";
import UserDropdown from "../common/UserDropdown";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../../../src/features/ui/sidebarSlice";
//import ToggleButton from "../ToggleButton";
export default function Topbar() {
  // const [search, setSearch] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const dispatch = useDispatch();
const user = JSON.parse(
  localStorage.getItem("user")
);



  return (
    <header className="bg-[#dbe9f5] border-b border-slate-200 px-6 h-16 flex items-center justify-between">
      
      {/* LEFT SECTION */}
      <div className="flex items-center gap-4">
        
        {/* Toggle */}
        <button
          onClick={() => dispatch(toggleSidebar())}
          className="p-2 rounded-lg hover:bg-slate-100"
        >
          ☰
        </button>

        {/* Search */}
        {/* <div className="relative w-64">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>

          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full h-10 pl-9 pr-4 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div> */}
      </div>

      {/* RIGHT SECTION */}
      <div className="flex items-center gap-4">
          {/* Theme Toggle */}
  {/* <ToggleButton /> */}
        {/* Bell */}
        {/* <button className="relative p-2 rounded-lg hover:bg-slate-100 text-slate-500 hover:text-slate-700">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span className="absolute top-1 right-1 w-2 h-2 bg-blue-500 rounded-full" />
        </button> */}

        {/* User */}
        <div className="relative">
          <button
            onClick={() => setOpenDropdown(!openDropdown)}
            className="flex items-center gap-2 dropdown-toggle p-1 rounded-lg hover:bg-slate-100"
          >
           <span className="text-sm font-semibold text-slate-700">
  {user?.first_name?.charAt(0).toUpperCase() +
    user?.first_name?.slice(1)}
</span>

            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-xs">
              {user?.first_name?.charAt(0).toUpperCase()}
            </div>
          </button>

          <UserDropdown
            isOpen={openDropdown}
            onClose={() => setOpenDropdown(false)}
          />
        </div>
      </div>
    </header>
  );
}

